import { httpClient } from './httpClient';

export type WarningLevel = 'NONE' | 'LOW' | 'CRITICAL' | 'DEPLETED';

export type AccountType = 'EARLY_ADOPTER' | 'STANDARD';

export interface CreditBalance {
  freePageBalance: number;
  monthlyConsumptionPages: number;
  monthlyConsumptionCostPence: number;
  currentRatePence: number;
  lifetimeUsed: number;
  suspended: boolean;
  hasActiveSubscription: boolean;
  warningLevel: WarningLevel;
  accountType: AccountType;
}

export interface CreditTransaction {
  id: string;
  userId: string;
  type: string;
  amount: number;
  balanceAfter: number;
  referenceId?: string;
  description?: string;
  caseId?: string;
  caseName?: string;
  costPence?: number;
  ratePence?: number;
  freePagesUsed?: number;
  paidPagesUsed?: number;
  createdAt: string;
}

export interface CreditTransactionPage {
  content: CreditTransaction[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const creditApi = {
  async getBalance(): Promise<CreditBalance> {
    return httpClient.get<CreditBalance>('/billing/credits/balance');
  },

  async getTransactions(page = 0, size = 20): Promise<CreditTransactionPage> {
    return httpClient.get<CreditTransactionPage>(
      `/billing/credits/transactions?page=${page}&size=${size}`
    );
  },

  async redeemInviteCode(code: string): Promise<{ creditsGranted: number }> {
    return httpClient.post<{ creditsGranted: number }>(
      '/auth/invite-codes/redeem',
      { code }
    );
  },
};
